// Seal block (product page): stamps each seal in once, when it scrolls into view.
// component-product-seal.css holds the hidden start (only with JavaScript) and the
// stamp; reduced motion shows the seals as they are.
(function () {
  'use strict';

  if (window.AxiomProductSeal) return;

  var observer = null;

  function stamp(element) {
    element.classList.add('is-stamped');
    if (observer) observer.unobserve(element);
  }

  function initialize(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    var seals = Array.prototype.slice.call(root.querySelectorAll('[data-seal-stamp]:not(.is-stamped)'));
    if (!seals.length) return;
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      seals.forEach(stamp);
      return;
    }
    if (!observer) {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) stamp(entry.target);
        });
      }, { threshold: 0.6 });
    }
    seals.forEach(function (seal) {
      observer.observe(seal);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initialize(document);
    });
  } else {
    initialize(document);
  }
  document.addEventListener('shopify:section:load', function (event) {
    initialize(event.target);
  });
  // Theme editor: a selected seal shows at once.
  document.addEventListener('shopify:block:select', function (event) {
    var target = event.target;
    if (target && target.matches && target.matches('[data-seal-stamp]')) stamp(target);
  });

  window.AxiomProductSeal = { initialize: initialize };
})();
